import * as Toast from "@radix-ui/react-toast";
import { Icon } from "react-migration/components/Icon";
import { Tooltip } from "react-migration/components/Tooltip";
import { useOnlineStatus } from "react-migration/domains/nav/hooks/useOnlineStatus";
import { Theme } from "react-migration/lib/theme/Theme";

export function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  return (
    <Toast.Provider>
      <Toast.Root
        open={!isOnline}
        duration={999999}
        className="flex flex-col items-start w-full max-w-sm overflow-hidden bg-red-100 rounded-lg shadow-lg text-blue-grey-950 min-w-max"
      >
        <div className="p-3 w-80">
          <div className="flex items-center justify-between gap-2">
            <Icon size="lg" icon="icon-lt-signal-wifi-error-line text-red-600" />
            <Toast.Title className="text-base font-medium">Network connection lost</Toast.Title>
            <Tooltip.Wrapper>
              <Tooltip.Content size="sm" side="bottom" align="end" theme={Theme.Light}>
                <Tooltip.Description>
                  You’re offline. You can view some recently loaded data, but actions like saving or accessing new data
                  won’t work until you’re reconnected.
                </Tooltip.Description>
              </Tooltip.Content>
              <Tooltip.Trigger>
                <i className="icon-lt-information-line print:hidden text-text-base-secondary-a" />
              </Tooltip.Trigger>
            </Tooltip.Wrapper>
          </div>
        </div>
      </Toast.Root>
      <Toast.Viewport className="fixed z-50 flex items-center transform -translate-x-1/2 top-28 left-1/2" />
    </Toast.Provider>
  );
}
